import { render } from "./TextAreaSegment.vue?vue&type=template&id=08a8e132"
import script from "./TextAreaSegment.vue?vue&type=script&lang=js"
export * from "./TextAreaSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__